/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AiTopResourceWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("AiTopResourceWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return AiTopResourceWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<AiTopResourceWidgetConfiguration>): AiTopResourceWidgetConfiguration {
        let obj = Object.assign(new AiTopResourceWidgetConfiguration(), model);
        AiTopResourceWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AiTopResourceWidgetConfiguration>): AiTopResourceWidgetConfiguration {
        if (!model) return null;
        return AiTopResourceWidgetConfiguration.newInstance(<AiTopResourceWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AiTopResourceWidgetConfiguration) {
        if (!obj) return;

        models.AiTopResourceWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AiTopResourceWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AiTopResourceWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * The AI resource type this widget instance is scoped to (agent, foundation_model, guardrail, ...).
     */
    resourceType: string;

}
